document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("form.formAddToCart");
  const lengthInput = document.getElementById("lengthInput");
  const widthInput  = document.getElementById("widthInput");
  const lengthError = document.querySelector(".length-error");
  const widthError  = document.querySelector(".width-error");
  const addBtn      = document.getElementById("AddToCart2");
  const tabButtons  = document.querySelectorAll('.dimension-tab-button');
  const dimensionOutput = document.querySelector('.dimension-tab-content .dimension-output');

  function parseSize(value) {
    const m = value.match(/(\d+)(?:")?\s*x\s*(\d+)(?:")?/);
    return m ? [parseInt(m[1],10), parseInt(m[2],10)] : [0,0];
  }

  function getSelector() {
    return form?.querySelector(".single-option-selector");
  }

  function getMaxSize(selector) {
    return Array.from(selector.options)
      .map(opt => parseSize(opt.value))
      .flat()
      .reduce((max, v) => Math.max(max, v), 0);
  }

  function clearErrors() {
    lengthError.textContent = "";
    widthError.textContent  = "";
    if (dimensionOutput) {
      dimensionOutput.textContent = "";
      dimensionOutput.className = dimensionOutput.className.replace(/\s*(area-output|error-output)/g, '');
    }
  }

  function showError(message) {
    if (dimensionOutput) {
      dimensionOutput.textContent = message;
      dimensionOutput.className = dimensionOutput.className.replace(/\s*(area-output|error-output)/g, '') + ' error-output';
    }
  }

  function showAreaOutput(area) {
    if (dimensionOutput) {
      dimensionOutput.dataset.addonquantity = Math.ceil(area);
      dimensionOutput.textContent = `Area: ${area.toFixed(2)} sq ft`;
      dimensionOutput.className = dimensionOutput.className.replace(/\s*(area-output|error-output)/g, '') + ' area-output';
    }
  }

  function calculateAndDisplayStandardArea() {
    const selector = getSelector();
    setTimeout(() => {  
      if (!selector || !selector.value) return;
      
      const [width, height] = parseSize(selector.value);
      if (width > 0 && height > 0) {      
        const areaInches = width * height;
        const areaSqFt = areaInches / 144;
        showAreaOutput(areaSqFt);
      }
    }, 100);
  }

  function validateInputs(maxSize) {
    let valid = true;
    const L = parseFloat(lengthInput.value);
    const W = parseFloat(widthInput.value);
    clearErrors();

    if (isNaN(L) || L <= 0) {
      // showError("Invalid length.");
      valid = false;
    } else if (L > maxSize) {
      showError(`Max length ${maxSize} inches.`);
      valid = false;
    } else if (isNaN(W) || W <= 0) {
      showError("Invalid width.");
      valid = false;
    } else if (W > maxSize) {
      showError(`Max width ${maxSize} inches.`);
      valid = false;
    }

    return valid;
  }

  function findNextBiggerVariant(userLength, userWidth, selector) {
    const options = Array.from(selector.options);
    let bestOption = null;
    let minArea = Infinity;

    options.forEach(opt => {
      const [optWidth, optHeight] = parseSize(opt.value);
      
      // Check if this option can accommodate the user's dimensions
      if (optWidth >= userLength && optHeight >= userWidth) {
        const optArea = optWidth * optHeight;
        if (optArea < minArea) {
          minArea = optArea;
          bestOption = opt;
        }
      }
      // Also check the flipped orientation
      else if (optWidth >= userWidth && optHeight >= userLength) {
        const optArea = optWidth * optHeight;
        if (optArea < minArea) {
          minArea = optArea;
          bestOption = opt;
        }
      }
    });

    // If no option can accommodate the dimensions, select the largest option
    if (!bestOption) {
      let maxArea = 0;
      options.forEach(opt => {
        const [optWidth, optHeight] = parseSize(opt.value);
        const optArea = optWidth * optHeight;
        if (optArea > maxArea) {
          maxArea = optArea;
          bestOption = opt;
        }
      });
    }

    return bestOption;
  }

  function updateClosestVariant() {
    const selector = getSelector();
    if (!selector) return;
    const maxSize = getMaxSize(selector);
    if (!validateInputs(maxSize)) return;

    const L = parseFloat(lengthInput.value);
    const W = parseFloat(widthInput.value);
    
    // Calculate and show area in square feet
    const areaInches = L * W;
    const areaSqFt = areaInches / 144; // Convert square inches to square feet
    showAreaOutput(areaSqFt);

    // Find the next bigger variant that can accommodate the dimensions
    const bestOption = findNextBiggerVariant(L, W, selector);
    
    if (bestOption) {
      selector.value = bestOption.value;
      selector.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function toggleAddButton() {
    const customActive = document
      .querySelector('.dimension-tab-button.active')
      .dataset.tab === 'custom';

    if (!customActive) {
      addBtn.removeAttribute('disabled');
      return;
    }
    
    // if custom: disable if any error showing
    const hasError = dimensionOutput && dimensionOutput.classList.contains('error-output');
    if (hasError) {
      addBtn.setAttribute('disabled','disabled');
    } else {
      addBtn.removeAttribute('disabled');
    }
  }

  // react on typing
  [lengthInput, widthInput].forEach(inp =>
    inp.addEventListener("keyup", () => {
      updateClosestVariant();
      toggleAddButton();
    })
  );

  // react on +/− clicks
  document.body.addEventListener("click", e => {
    if (e.target.closest(".velaQtyPlus, .velaQtyMinus")) {
      setTimeout(() => {
        updateClosestVariant();
        toggleAddButton();
      }, 10);
    }
  });

  // wait for the variant select to appear, then initialize
  const observer = new MutationObserver(_ => {
    const selector = getSelector();
    if (selector) {
      observer.disconnect();
      
      // Calculate and display area on page load for standard tab
      calculateAndDisplayStandardArea();
      
      // Add event listener for selector changes
      selector.addEventListener('change', () => {
        const activeTab = document.querySelector('.dimension-tab-button.active');
        if (activeTab && activeTab.dataset.tab === 'standard') {
          calculateAndDisplayStandardArea();
        }
      });
    }
  });
  
  observer.observe(form, { childList: true, subtree: true });

  // handle tab switches
  tabButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      // toggle active classes
      tabButtons.forEach(b=>b.classList.remove("active"));
      document.querySelectorAll(".dimension-tab-pane")
        .forEach(p=>p.classList.remove("active"));
      btn.classList.add("active");
      document.getElementById(`dimension-tab-${btn.dataset.tab}`)
        .classList.add("active");

      const selector = getSelector();

      if (btn.dataset.tab === "custom" && selector) {
        // auto‑fill from current variant
        const [w,h] = parseSize(selector.value);
        lengthInput.value = w;
        widthInput.value  = h;
        clearErrors();
        updateClosestVariant();
      }
      else if (btn.dataset.tab === "standard") {
        // clear inputs and errors
        lengthInput.value = "";
        widthInput.value  = "";
        clearErrors();
        // Calculate and display area for standard tab
        calculateAndDisplayStandardArea();
      }

      toggleAddButton();
    });
  });

  // custom Tab‐keybing
  const inputs = Array.from(document.querySelectorAll(".custom-dimensions input"));
  inputs.forEach((inp,i) =>
    inp.addEventListener("keydown", e => {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        const next = inputs[i+1];
        return next ? next.focus() : inp.blur();
      }
    })
  );
});